import { useContext } from 'react';
import { useOptimizelyFeature } from '@atc/optimizely-toolkit';
import cloneSnakeCaseProperties from './cloneSnakeCaseProperties';
import Context from './Context';
import getFeature from './getFeature';
export default function useFeatures(featureKeys) {
  if (featureKeys === void 0) {
    featureKeys = [];
  }
  const featuresContext = useContext(Context) || {};
  const optimizely = useOptimizelyFeature();
  const features = featureKeys.reduce((acc, featureKey) => ({
    ...acc,
    [featureKey]: getFeature(featureKey, {
      featuresContext,
      optimizely
    })
  }), {});

  // duplicate snake_case property keys
  return Object.entries(features).reduce(cloneSnakeCaseProperties, {});
}